// extracted by mini-css-extract-plugin
export default {"sider":"styles_sider__Whk88","content":"styles_content__9p+MS","loadingContainer":"styles_loadingContainer__9mSEc"};